// extracted by mini-css-extract-plugin
export var cancelButton = "_n6-5";
export var content = "_n6-3";
export var createButton = "_n6-6";
export var drawerContainer = "_n6-0";
export var footer = "_n6-2";
export var header = "_n6-1";
export var orderFormColumn = "_n6-4";